let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("d0FRs"), load("i6hfz"), load("eWCiQ")]).then(() => parcelRequire('edScR'));